const initialvalues = {
    setDueDetailslogintapout: [],
    bakFlaglogintapout: false,

    setOwnerDetailsbyRadiologintapout: [],
    setfilterOwnerDetailsbyRadiologintapout: [],

    backFlag1logintapout: "fresh",
    formikValueslogintapout: {},

    paymentlogintapout: "",
}


export default function OutsideCellTowerReducer(details = initialvalues, action) {


    switch (action.type) {
        case
            "OUTCELLPAYMENTLOGIN":
            return { ...details, paymentlogintapout: action.payload };
        case
            "OUTCELLSETOWNERDETAILSBYRADIOLOGIN":
            return { ...details, setOwnerDetailsbyRadiologintapout: action.payload };
        case
            "OUTCELLSETFILTEROWNERDETAILSBYRADIOLOGIN":
            return { ...details, setfilterOwnerDetailsbyRadiologintapout: action.payload };
        case
            "OUTCELLSETDUEDETAILSLOGIN":
            return { ...details, setDueDetailslogintapout: action.payload };

        case
            "OUTCELLFORMIKVALUESLOGIN":
            return { ...details, formikValueslogintapout: action.payload };
        case "OUTCELLBACKFLAGLOGIN":
            return { ...details, bakFlaglogintapout: action.payload };
        case
            "OUTCELLBACKFLAG1LOGIN":
            return { ...details, backFlag1logintapout: action.payload };

        default:

            return details;
    }
}